// §2.4 Skeleton shaped like the content it stands in for; no shimmer, no spinner.
// width/height are geometry, passed through as inline style.
export default function Skeleton({ variant = 'line', width, height, label }) {
  return <span className={`ui ui-skel ui-skel--${variant}`} style={{ width, height }} role={label ? 'status' : undefined} aria-label={label} />;
}
